import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-darts',
    templateUrl: './default/darts/darts.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, PipesModule]
})
export class DartsComponent extends UnitsDistributionBase {
  // Used for DARTS_CORRECT_SCORE, DARTS_H2H
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}